import { getOrigin } from '../libs/urlUtils';
import { isWixDomain } from '../utils/isWixDomain';
import { getPanoramaClient } from './panorama';

export type InteractionKey = 'search' | 'pagination' | 'category-switch' | 'mobile-preview';
let loadStarted = false;
let loadFinished = false;

// Mirrors the wrong-origin guards in v1/client.tsx and v2/client.tsx, where the app never renders.
const isAppOrigin = () => {
  const v2BaseURL: string | undefined = window.__INITIAL_STORES_STATE__?.config?.baseURL;
  return v2BaseURL ? window.location.origin === getOrigin(v2BaseURL) : isWixDomain(window.location.hostname);
};

export const startMonitoring = () => {
  if (!isAppOrigin()) {
    return;
  }
  const client = getPanoramaClient();
  if (client && !loadStarted) {
    client.reportLoadStart();
    loadStarted = true;
  }
};

export const monitoring = {
  appLoaded: () => {
    if (!loadStarted || loadFinished) {
      return;
    }
    getPanoramaClient()?.reportLoadFinish();
    loadFinished = true;
  },
  interactionStarted: (key: InteractionKey) => getPanoramaClient()?.transaction(key).start(),
  interactionEnded: (key: InteractionKey) => getPanoramaClient()?.transaction(key).finish(),
};
